// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `    
	.designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker.react-colorful {
        width: 100% !important;
    }
    .designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker.react-colorful {
     	margin: auto;
    }
    .designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker .react-colorful__saturation {
		border: 0;
		border-radius: 2px;
	}
	.designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker .react-colorful__hue {
		border: 0;
		border-radius: 4px;
		cursor: pointer;
		height: 8px;
		margin: 16px 0 10px;
	}
	.designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker .react-colorful__alpha {
		border: 0;
		border-radius: 4px;
		cursor: pointer;
		height: 8px;
		margin: 8px 0 10px;
		background-size: 8px;
	}
	.designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker .react-colorful__hue-pointer {
		-webkit-box-shadow: none;
		        box-shadow: none;
		height: 16px;
		width: 16px;
	}
    .designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker .react-colorful__hue-pointer .react-colorful__pointer-fill {
		background-color: transparent !important;
    }
	.designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker .react-colorful__alpha-pointer {
		-webkit-box-shadow: none;
		        box-shadow: none;
		height: 16px;
		width: 16px;
	}
    .designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker .react-colorful__alpha-pointer .react-colorful__pointer-fill {
        background-color: white !important;
    }
	.designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker .react-colorful__saturation-pointer {
		height: 8px;
		width: 8px;
	}`, "",{"version":3,"sources":["webpack://./src/designSystem/components/colorPicker/ColorPicker.module.css"],"names":[],"mappings":";CACC;QAEO,sBAAsB;IAC1B;IAHH;MACK,YAAY;IAEd;IACA;EACF,SAAS;EACT,kBAAkB;CACnB;CACA;EACC,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,mBAAmB;CACpB;CACA;EACC,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,oBAAoB;CACrB;CACA;EACC,wBAAgB;UAAhB,gBAAgB;EAChB,YAAY;EACZ,WAAW;CACZ;IACG;EACF,wCAAwC;IACtC;CACH;EACC,wBAAgB;UAAhB,gBAAgB;EAChB,YAAY;EACZ,WAAW;CACZ;IACG;QACI,kCAAkC;IACtC;CACH;EACC,WAAW;EACX,UAAU;CACX","sourcesContent":["    \n\t.centricRgbColorPicker:global(.react-colorful) {\n     \tmargin: auto;\n        width: 100% !important;\n    }\n    .centricRgbColorPicker :global(.react-colorful__saturation) {\n\t\tborder: 0;\n\t\tborder-radius: 2px;\n\t}\n\t.centricRgbColorPicker :global(.react-colorful__hue) {\n\t\tborder: 0;\n\t\tborder-radius: 4px;\n\t\tcursor: pointer;\n\t\theight: 8px;\n\t\tmargin: 16px 0 10px;\n\t}\n\t.centricRgbColorPicker :global(.react-colorful__alpha) {\n\t\tborder: 0;\n\t\tborder-radius: 4px;\n\t\tcursor: pointer;\n\t\theight: 8px;\n\t\tmargin: 8px 0 10px;\n\t\tbackground-size: 8px;\n\t}\n\t.centricRgbColorPicker :global(.react-colorful__hue-pointer) {\n\t\tbox-shadow: none;\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n    .centricRgbColorPicker :global(.react-colorful__hue-pointer) :global(.react-colorful__pointer-fill) {\n\t\tbackground-color: transparent !important;\n    }\n\t.centricRgbColorPicker :global(.react-colorful__alpha-pointer) {\n\t\tbox-shadow: none;\n\t\theight: 16px;\n\t\twidth: 16px;\n\t}\n    .centricRgbColorPicker :global(.react-colorful__alpha-pointer) :global(.react-colorful__pointer-fill) {\n        background-color: white !important;\n    }\n\t.centricRgbColorPicker :global(.react-colorful__saturation-pointer) {\n\t\theight: 8px;\n\t\twidth: 8px;\n\t}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centricRgbColorPicker": `designSystem-components-colorPicker-ColorPicker-module-centricRgbColorPicker`
};
module.exports = ___CSS_LOADER_EXPORT___;
